import { z } from 'zod';
// === ParsedPrice (хранится в price_versions.parsed_data) ===
export const ParsedLegalEntity = z.object({
    name: z.string(),
    warehouse: z.string().nullable(),
    city: z.string().nullable(),
    brandLabel: z.string().nullable(),
    inn: z.string().nullable(),
    paymentDelay: z.number().int().nullable(),
    deliveryTime: z.number().int().nullable(),
    creditLimit: z.string().nullable(),
    pdzDelay: z.number().int().nullable(),
    edoId: z.string().nullable(),
    phone: z.string().nullable(),
    contactName: z.string().nullable(),
    contactRole: z.string().nullable(),
    telegram: z.string().nullable(),
    email: z.string().nullable(),
    prices: z.record(z.string(), z.number()),
});
export const ParsedPrice = z.object({
    groupLabels: z.array(z.string()),
    legalEntities: z.array(ParsedLegalEntity),
});
// === Diff ===
export const PriceDiff = z.object({
    groups: z.object({
        added: z.array(z.string()),
        removed: z.array(z.string()),
    }),
    legalEntities: z.object({
        added: z.array(z.object({
            name: z.string(),
            inn: z.string().nullable(),
            paymentDelay: z.number().int().nullable(),
            creditLimit: z.string().nullable(),
            pdzDelay: z.number().int().nullable(),
            prices: z.record(z.string(), z.number()),
        })),
        removed: z.array(z.object({ id: z.string(), name: z.string() })),
        attrChanged: z.array(z.object({
            id: z.string(),
            name: z.string(),
            changes: z.record(z.string(), z.tuple([z.unknown(), z.unknown()])),
        })),
    }),
    prices: z.object({
        added: z.array(z.object({ legalEntity: z.string(), group: z.string(), value: z.number() })),
        removed: z.array(z.object({ legalEntity: z.string(), group: z.string(), value: z.number() })),
        changed: z.array(z.object({
            legalEntity: z.string(), group: z.string(),
            old: z.number(), new: z.number(),
        })),
    }),
    summary: z.object({
        groupsAdded: z.number(),
        groupsRemoved: z.number(),
        legalEntitiesAdded: z.number(),
        legalEntitiesRemoved: z.number(),
        legalEntitiesAttrChanged: z.number(),
        pricesAdded: z.number(),
        pricesRemoved: z.number(),
        pricesChanged: z.number(),
    }),
});
// === Listing ===
export const PriceVersionStatus = z.enum([
    'pending', 'current', 'archived', 'rejected', 'superseded_by_apply',
]);
export const PriceVersionSummary = z.object({
    id: z.string(),
    status: PriceVersionStatus,
    fileName: z.string(),
    fileSize: z.number(),
    uploadedAt: z.string(),
    uploadedBy: z.string(),
    uploadedByEmail: z.string(),
    decidedAt: z.string().nullable(),
    decidedBy: z.string().nullable(),
    decidedByEmail: z.string().nullable(),
});
// === Render ===
export const RenderRow = z.object({
    legalEntityId: z.string(),
    name: z.string(),
    warehouse: z.string().nullable(),
    city: z.string().nullable(),
    brandLabel: z.string().nullable(),
    inn: z.string().nullable(),
    paymentDelay: z.number().int().nullable(),
    deliveryTime: z.number().int().nullable(),
    creditLimit: z.string().nullable(),
    pdzDelay: z.number().int().nullable(),
    edoId: z.string().nullable(),
    phone: z.string().nullable(),
    contactName: z.string().nullable(),
    contactRole: z.string().nullable(),
    telegram: z.string().nullable(),
    email: z.string().nullable(),
    prices: z.record(z.string(), z.number().nullable()),
});
export const RenderResponse = z.object({
    versionId: z.string(),
    uploadedAt: z.string(),
    groupLabels: z.array(z.string()),
    rows: z.array(RenderRow),
});
//# sourceMappingURL=commercial-terms.js.map